import styled from '@emotion/styled';
import { colorConstants } from 'config/colorConstants';
import { PPA_SIM_SEARCH_EMPTY_RESULT } from 'constants/ppaTestIds';

const StyledSearchEmptyResult = styled.div`
    flex-shrink: 0;
    width: 100%;
    min-height: 30px;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: ${colorConstants.toolbarLabelGrey};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
`;

const SearchEmptyResult = () => (
    <StyledSearchEmptyResult
        data-empty-search-result
        data-testid={PPA_SIM_SEARCH_EMPTY_RESULT}
    >
        No results
    </StyledSearchEmptyResult>
);

export default SearchEmptyResult;
